import { useHistory, useRouteMatch } from 'react-router-dom';

export const useMenuRootRoute = () => {
  const { url } = useRouteMatch();
  const history = useHistory();
  const isMenuEditor = history.location.pathname.includes('/menu-editor');
  const isSharedMenu = history.location.pathname.includes('/shared-menu');
  const targetSuffix = isMenuEditor ? '/menu-editor' : isSharedMenu ? '/shared-menu' : '';
  const [entityUrl] = url.split(targetSuffix);
  const baseUrl = entityUrl.concat(targetSuffix);
  const isExperienceFlow = history.location.pathname.includes('/experience');

  return { baseUrl, entityUrl, isExperienceFlow };
};
